import { Expose, Type } from 'class-transformer';
import { RECEIVE_TIME_SC } from 'src/app/common/const';
import { VehicleLayoutType } from 'src/app/vehicles/model/vehicle-layout-type';
import { StopPile } from '../../vehicles/model/stop-pile';
import { Vehicle } from '../../vehicles/model/vehicle';
import { StopPileStatEventType } from './stop-pile-stat-event-type';

export const PEOPLE_COUNT_COLUMN_NAME = 'peopleCount';
export const PEOPLE_ENTER_COLUMN_NAME = 'peopleEnter';
export const PEOPLE_EXIT_COLUMN_NAME = 'peopleExit';
const PEOPLE_ENTER_DOOR = 'people_enter_door';
const PEOPLE_EXIT_DOOR = 'people_exit_door';
export const PEOPLE_COUNTERS_RAW = [PEOPLE_COUNT_COLUMN_NAME, PEOPLE_ENTER_COLUMN_NAME, PEOPLE_EXIT_COLUMN_NAME,
  `${PEOPLE_ENTER_DOOR}1`, `${PEOPLE_ENTER_DOOR}2`, `${PEOPLE_ENTER_DOOR}3`, `${PEOPLE_ENTER_DOOR}4`, `${PEOPLE_ENTER_DOOR}5`, `${PEOPLE_ENTER_DOOR}6`,
  `${PEOPLE_EXIT_DOOR}1`, `${PEOPLE_EXIT_DOOR}2`, `${PEOPLE_EXIT_DOOR}3`, `${PEOPLE_EXIT_DOOR}4`, `${PEOPLE_EXIT_DOOR}5`, `${PEOPLE_EXIT_DOOR}6`];
export const PEOPLE_COUNT_CORRECTED_COLUMN_NAME = 'peopleCountCorrected';
export const PEOPLE_ENTER_CORRECTED_COLUMN_NAME = 'peopleEnterCorrected';
export const PEOPLE_EXIT_CORRECTED_COLUMN_NAME = 'peopleExitCorrected';
const PEOPLE_ENTER_DOOR_CORRECTED = 'people_enter_door_corrected';
const PEOPLE_EXIT_DOOR_CORRECTED = 'people_exit_door_corrected';
export const PEOPLE_COUNTERS_CORRECTED = [PEOPLE_COUNT_CORRECTED_COLUMN_NAME, PEOPLE_ENTER_CORRECTED_COLUMN_NAME, PEOPLE_EXIT_CORRECTED_COLUMN_NAME,
  `${PEOPLE_ENTER_DOOR_CORRECTED}1`, `${PEOPLE_ENTER_DOOR_CORRECTED}2`, `${PEOPLE_ENTER_DOOR_CORRECTED}3`,
  `${PEOPLE_ENTER_DOOR_CORRECTED}4`, `${PEOPLE_ENTER_DOOR_CORRECTED}5`, `${PEOPLE_ENTER_DOOR_CORRECTED}6`,
  `${PEOPLE_EXIT_DOOR_CORRECTED}1`, `${PEOPLE_EXIT_DOOR_CORRECTED}2`, `${PEOPLE_EXIT_DOOR_CORRECTED}3`,
  `${PEOPLE_EXIT_DOOR_CORRECTED}4`, `${PEOPLE_EXIT_DOOR_CORRECTED}5`, `${PEOPLE_EXIT_DOOR_CORRECTED}6`];
export const BUS_FILL_COLUMN_NAME = 'busFill';
export const BUS_FILL_CORRECTED_COLUMN_NAME = 'busFillCorrected';
export const TIMETABLE_MSECS = 'timetable_msecs';

export class StopPileStats {

  @Expose({ name: 'stat_id' })
  id: number;

  @Expose({ name: RECEIVE_TIME_SC })
  @Type(() => Date)
  receiveTime: Date;

  @Expose({ name: 'people_count' })
  peopleCount?: number;

  @Expose({ name: 'people_count_dvs' })
  peopleCountDvs?: number;

  @Expose({ name: 'people_enter' })
  peopleEnter?: number;

  @Expose({ name: 'people_exit' })
  peopleExit?: number;

  @Expose({ name: 'people_count_corrected' })
  peopleCountCorrected?: number;

  @Expose({ name: 'people_enter_corrected' })
  peopleEnterCorrected?: number;

  @Expose({ name: 'people_exit_corrected' })
  peopleExitCorrected?: number;

  @Expose({ name: 'people_enter_tall' })
  peopleEnterTall?: number;

  @Expose({ name: 'people_exit_tall' })
  peopleExitTall?: number;

  @Expose({ name: 'people_enter_short' })
  peopleEnterShort?: number;

  @Expose({ name: 'people_exit_short' })
  peopleExitShort?: number;

  @Expose({ name: 'line' })
  line?: string;

  @Expose({ name: 'route_code' })
  routeCode?: string;

  @Expose({ name: 'route_id' })
  routeId?: number;

  @Expose({ name: 'stop_pile' })
  @Type(() => StopPile)
  stopPile?: StopPile;

  @Expose({ name: 'vehicle' })
  @Type(() => Vehicle)
  vehicle: Vehicle;

  @Expose({ name: 'team' })
  team?: string;

  @Expose({ name: 'typeofday' })
  typeofday?: string;

  @Expose({ name: TIMETABLE_MSECS })
  @Type(() => Date)
  timetableTime: Date;

  @Expose({ name: 'busstop_number' })
  busStopNumber?: number;

  @Expose({ name: 'in_zone' })
  inZone?: boolean;

  @Expose({ name: 'latitude' })
  latitude?: number;

  @Expose({ name: 'longitude' })
  longitude?: number;

  @Expose({ name: 'event_type' })
  eventType?: StopPileStatEventType;

  @Expose({ name: 'direction_name' })
  directionName?: string;

  @Expose({ name: 'user_id' })
  userId?: string;

  @Expose({ name: 'user_name' })
  userName?: string;

  @Expose({ name: 'agid' })
  agid?: number;

  @Expose({ name: 'time_id' })
  timeId?: number;

  @Expose({ name: 'course' })
  course?: string;

  timetableDeviation?: number;

  @Expose({ name: 'course_id' })
  courseId?: number;

  @Expose({ name: 'departure_time' })
  @Type(() => Date)
  departureTime: Date;

  @Expose({ name: 'bus_fill' })
  busFill?: number;

  @Expose({ name: 'bus_fill_corrected' })
  busFillCorrected?: number;

  @Expose({ name: 'is_imported_stats' })
  isImportedStats: boolean;

  @Expose({ name: 'planned_vehicle' })
  plannedVehicleSideNumber: string;

  @Expose({ name: 'planned_type' })
  plannedVehicleType: VehicleLayoutType;

  @Expose({ name: 'inside_temperature' })
  insideTemperature: number;

  @Expose({ name: 'outside_temperature' })
  outsideTemperature: number;

  @Expose({ name: 'vehicle_type' })
  vehicleType: VehicleLayoutType;

  @Expose({ name: 'tb_tid_course_no' })
  tbTidCourseNo: number;

  courseDate: string;

  @Expose({ name: 'vehicle_passengers_size' })
  vehiclePassengersSize: number;

  @Expose({ name: 'vehicle_named_type' })
  vehicleNamedType: string;

  @Expose({ name: 'course_identifier' })
  courseIdentifier: string;

  @Expose({ name: 'enter_zone_time' })
  @Type(() => Date)
  enterZoneTime: Date;

  @Expose({ name: 'leave_zone_time' })
  @Type(() => Date)
  leaveZoneTime: Date;

  @Expose({ name: 'tickets' })
  tickets: number;

  @Expose({ name: 'mileage' })
  mileage: number;

  @Expose({ name: 'order_by_brigade' })
  orderByBrigade: number;
}
